import createBottomComponent from "../../../../helpers/common/CoreInputText/components/Bottom/fabric";
import { INPUT_TEXTAREA_DISPLAY_NAME } from "../../utils/core";

export const Component = createBottomComponent(INPUT_TEXTAREA_DISPLAY_NAME);
export default Component;
